/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListPrescriptionsResponseBody,
  ListPrescriptionsResponseBody$inboundSchema,
} from "../components/listprescriptionsresponsebody.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PlatformKillswitchesNumberListPrescriptionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PlatformKillswitchesNumberListPrescriptionsRequest = {
  organizationId: string;
  limit?: number | undefined;
  afterId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type PlatformKillswitchesNumberListPrescriptionsResponse = {
  result: ListPrescriptionsResponseBody;
};

/** @internal */
export type PlatformKillswitchesNumberListPrescriptionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberListPrescriptionsSecurity$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberListPrescriptionsSecurity$Outbound,
    PlatformKillswitchesNumberListPrescriptionsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberListPrescriptionsSecurityToJSON(
  platformKillswitchesNumberListPrescriptionsSecurity:
    PlatformKillswitchesNumberListPrescriptionsSecurity,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberListPrescriptionsSecurity$outboundSchema.parse(
      platformKillswitchesNumberListPrescriptionsSecurity,
    ),
  );
}

/** @internal */
export type PlatformKillswitchesNumberListPrescriptionsRequest$Outbound = {
  organization_id: string;
  limit?: number | undefined;
  after_id?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberListPrescriptionsRequest$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberListPrescriptionsRequest$Outbound,
    PlatformKillswitchesNumberListPrescriptionsRequest
  > = z.pipe(
    z.object({
      organizationId: z.string(),
      limit: z.optional(z.int()),
      afterId: z.optional(z.string()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        organizationId: "organization_id",
        afterId: "after_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberListPrescriptionsRequestToJSON(
  platformKillswitchesNumberListPrescriptionsRequest:
    PlatformKillswitchesNumberListPrescriptionsRequest,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberListPrescriptionsRequest$outboundSchema.parse(
      platformKillswitchesNumberListPrescriptionsRequest,
    ),
  );
}

/** @internal */
export const PlatformKillswitchesNumberListPrescriptionsResponse$inboundSchema:
  z.ZodMiniType<PlatformKillswitchesNumberListPrescriptionsResponse, unknown> =
    z.pipe(
      z.object({
        Result: ListPrescriptionsResponseBody$inboundSchema,
      }),
      z.transform((v) => {
        return remap$(v, {
          "Result": "result",
        });
      }),
    );

export function platformKillswitchesNumberListPrescriptionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  PlatformKillswitchesNumberListPrescriptionsResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PlatformKillswitchesNumberListPrescriptionsResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PlatformKillswitchesNumberListPrescriptionsResponse' from JSON`,
  );
}
